// @flow
import React from 'react';
import styles from './menuBar.scss';
import { isClient, isIE } from '../../../services/helpers';

const closeBtnUrl = require('../../../assets/images/close_icn_white.svg');

type Props = {
  menuBarState: Object,
  toggleMenuBarDisplay: Function,
  navigateToRoute: Function,
  userProfile: Object
};

class MenuBar extends React.Component<Props> {
  isTabVisible(routeObj) {
    return !(routeObj.subRoutes && !routeObj.subRoutes.length);
  }

  renderSubRoutes(subRoutesArr: Array<any>) {
    const subRouteCells = subRoutesArr.map((subRouteObj, i) => (
      <div
        key={i}
        className={`${styles.subRouteCellWrapper} l-row a-center`}
        onClick={() => this.props.navigateToRoute(subRouteObj)}
      >
        {subRouteObj.title}
      </div>
    ));
    return <div className={`${styles.subRoutesWrapper}`}>{subRouteCells}</div>;
  }

  renderMainRoutes() {
    let routeTitleWrapperIEStyle = {};
    let imageForIeStyle = {};
    if (isIE()) {
      routeTitleWrapperIEStyle = {
        flexBasis: 'auto',
        lineHeight: '50px'
      };
      imageForIeStyle = {
        height: '30px',
        width: 'auto',
        position: 'relative',
        top: '10px'
      };
    }
    return this.props.menuBarState.columnWiseRoutes.map(
      (singleColumnRoutesArr, i) => {
        const columnCssClass = `column${i + 1}Wrapper`;
        return (
          <div
            key={i}
            className={`${styles.routesColumnWrapper} ${styles[columnCssClass]}`}
          >
            {singleColumnRoutesArr.map((routeObj, index) =>
              this.isTabVisible(routeObj) ? (
                <div
                  key={index}
                  className={`${styles.routeCellWrapper} ${
                    routeObj.cellClassName ? styles[routeObj.cellClassName] : ''
                  } l-col j-center  ${
                    routeObj.subRoutes && routeObj.subRoutes.length
                      ? styles.routeSubRouteCellWrapper
                      : ''
                  } `}
                >
                  <div
                    className={`${styles.routeTitleWrapper} flex l-row`}
                    style={routeTitleWrapperIEStyle}
                  >
                    {routeObj.icnFile &&
                      (isClient(this.props.userProfile) ? (
                        <div
                          className={`flex-30 l-row j-center ${
                            styles.menuIcn
                          } ${
                            routeObj.icnClassName
                              ? styles[routeObj.icnClientClassName]
                              : ''
                          }`}
                        >
                          <img
                            src={routeObj.icnFileClient}
                            alt="img"
                            style={imageForIeStyle}
                          />
                        </div>
                      ) : (
                        <div
                          className={`flex-30 l-row j-center ${
                            styles.menuIcn
                          } ${
                            routeObj.icnClassName
                              ? styles[routeObj.icnClassName]
                              : ''
                          }`}
                        >
                          <img
                            src={routeObj.icnFile}
                            alt="img"
                            style={imageForIeStyle}
                          />
                        </div>
                      ))}
                    <div
                      className={`${styles.routeTitle} flex-85 l-row a-center`}
                      onClick={() => this.props.navigateToRoute(routeObj)}
                    >
                      {routeObj.title}
                      {this.props.directDeliveryApprovalCount &&
                      routeObj.title === 'DIRECT DELIVERY APPROVAL DASHBOARD'
                        ? ' | ' + this.props.directDeliveryApprovalCount
                        : null}
                    </div>
                  </div>

                  {routeObj.subRoutes && routeObj.subRoutes.length
                    ? this.renderSubRoutes(routeObj.subRoutes)
                    : null}
                </div>
              ) : null
            )}
          </div>
        );
      }
    );
  }
  render() {
    return (
      <div
        className={` l-col ${
          this.props.menuBarState.isMenuBarVisible
            ? styles.menuBarWrapper
            : styles.hiddenWrapper
        }  `}
      >
        <div className={`${styles.menuBarContainer} flex-auto`}>
          <div
            className={` ${styles.closeBtnWrapper} l-row a-center flex cursor-p`}
            onClick={() => this.props.toggleMenuBarDisplay(false)}
          >
            <img src={closeBtnUrl} alt="" />
            <div className={` ${styles.closeBtnLabel} l-row  j-center`}>
              CLOSE
            </div>
          </div>
          <div className={`${styles.routesWrapper} l-row`}>
            {this.renderMainRoutes()}
          </div>
          {/* <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px'
            }}
          >
            Scroll To View More
          </div> */}
        </div>
        <div
          className={`${styles.menuBarBackdrop} flex-auto`}
          onClick={() => this.props.toggleMenuBarDisplay(false)}
        />
      </div>
    );
  }
}

export default MenuBar;
